export default {
  walk: 'Caminando',
  bike: 'Bicicleta',
  ebike: 'Bici con motor',
  moto: 'Moto',
  car: 'Auto'
}
